function safeUrl(url) {
  if (!url || typeof url !== 'string') return '';
  try {
    const u = new URL(url, window.location.origin);
    const p = u.protocol.toLowerCase();
    if (p === 'http:' || p === 'https:') return u.href;
    return '';
  } catch {
    return '';
  }
}

function normalizeContentLabels(biz) {
  try {
    let v = biz?.content_labels;
    if (!v && biz?.contentLabels) v = biz.contentLabels;
    if (typeof v === 'string' && v.trim()) {
      try { v = JSON.parse(v); } catch (_) {}
    }
    if (!Array.isArray(v)) return [];
    return v
      .map((x) => (x == null ? '' : String(x)))
      .map((x) => x.trim())
      .filter(Boolean)
      .slice(0, 1);
  } catch {
    return [];
  }
}

function labelMeta(raw) {
  const key = (raw || '').toString().trim().toLowerCase();
  if (key === 'adulto' || key === '+18' || key === '18+' || key === 'adult') return { key: 'adulto', text: '+18' };
  if (key === 'infantil' || key === 'kids' || key === 'child') return { key: 'infantil', text: 'Infantil' };
  if (key === 'familiar' || key === 'family') return { key: 'familiar', text: 'Familiar' };
  return { key: 'generic', text: raw };
}

function bindWhatsAppTrackingOnce() {
  try {
    if (window.__pyaWhatsAppTrackingBound) return;
    window.__pyaWhatsAppTrackingBound = true;
    document.addEventListener('click', (e) => {
      const a = e.target && e.target.closest ? e.target.closest('a[data-pya-track="whatsapp"]') : null;
      if (!a) return;
      try {
        const id = decodeURIComponent(a.getAttribute('data-biz-id') || '');
        const nm = decodeURIComponent(a.getAttribute('data-biz-name') || '');
        if (window.pyaTracker && typeof window.pyaTracker.trackWhatsAppClick === 'function') {
          window.pyaTracker.trackWhatsAppClick(id, nm);
        }
      } catch (_) { /* noop */ }
    }, { capture: true });
  } catch (_) { /* noop */ }
}

export function createContentLabelBadgesElement(biz) {
  try {
    const labels = normalizeContentLabels(biz);
    if (!labels.length) return null;

    const wrap = document.createElement('div');
    wrap.className = 'pya-content-labels';
    wrap.style.cssText = 'position:absolute; top:12px; right:12px; z-index:11; display:flex; gap:6px; flex-wrap:wrap; max-width:70%; justify-content:flex-end;';

    labels.forEach((raw) => {
      const meta = labelMeta(raw);
      const sp = document.createElement('span');
      sp.className = `pya-content-label pya-content-label--${meta.key}`;
      sp.textContent = meta.text;
      const base = 'display:inline-flex;align-items:center;justify-content:center;padding:6px 10px;border-radius:999px;font-weight:900;font-size:12px;letter-spacing:.02em;backdrop-filter:blur(6px);';
      if (meta.key === 'adulto') {
        sp.style.cssText = base + 'background:rgba(220,38,38,.92);color:#fff;box-shadow:0 10px 22px rgba(220,38,38,.25);border:1px solid rgba(255,255,255,.25);';
      } else if (meta.key === 'infantil') {
        sp.style.cssText = base + 'background:rgba(16,185,129,.92);color:#fff;box-shadow:0 10px 22px rgba(16,185,129,.18);border:1px solid rgba(255,255,255,.25);';
      } else if (meta.key === 'familiar') {
        sp.style.cssText = base + 'background:rgba(37,99,235,.92);color:#fff;box-shadow:0 10px 22px rgba(37,99,235,.18);border:1px solid rgba(255,255,255,.25);';
      } else {
        sp.style.cssText = base + 'background:rgba(15,23,42,.72);color:#fff;border:1px solid rgba(255,255,255,.18);';
      }
      wrap.appendChild(sp);
    });
    return wrap;
  } catch {
    return null;
  }
}

export function createContentLabelChipElement(biz) {
  try {
    const labels = normalizeContentLabels(biz);
    if (!labels.length) return null;
    const meta = labelMeta(labels[0]);
    const sp = document.createElement('span');
    sp.className = `pya-content-label pya-content-label--${meta.key}`;
    sp.textContent = meta.text;
    const base = 'display:inline-flex;align-items:center;justify-content:center;padding:6px 10px;border-radius:999px;font-weight:900;font-size:12px;letter-spacing:.02em;white-space:nowrap;flex-shrink:0;';
    if (meta.key === 'adulto') {
      sp.style.cssText = base + 'background:rgba(220,38,38,.92);color:#fff;box-shadow:0 10px 22px rgba(220,38,38,.20);border:1px solid rgba(255,255,255,.22);';
    } else if (meta.key === 'infantil') {
      sp.style.cssText = base + 'background:rgba(16,185,129,.92);color:#fff;box-shadow:0 10px 22px rgba(16,185,129,.16);border:1px solid rgba(255,255,255,.22);';
    } else if (meta.key === 'familiar') {
      sp.style.cssText = base + 'background:rgba(37,99,235,.92);color:#fff;box-shadow:0 10px 22px rgba(37,99,235,.16);border:1px solid rgba(255,255,255,.22);';
    } else {
      sp.style.cssText = base + 'background:rgba(15,23,42,.72);color:#fff;border:1px solid rgba(255,255,255,.18);';
    }
    return sp;
  } catch {
    return null;
  }
}

export function renderSocialMediaIcons(socialMedia, businessId = null, businessName = null) {
  if (!socialMedia || typeof socialMedia !== 'object') {
    return '';
  }

  bindWhatsAppTrackingOnce();

  const socialNetworks = [
    { key: 'facebook', icon: 'fab fa-facebook-f', color: '#1877F2', label: 'Facebook' },
    { key: 'instagram', icon: 'fab fa-instagram', color: '#E4405F', label: 'Instagram' },
    { key: 'twitter', icon: 'fab fa-x-twitter', color: '#000000', label: 'X' },
    { key: 'tiktok', icon: 'fab fa-tiktok', color: '#000000', label: 'TikTok' },
    { key: 'whatsapp', icon: 'fab fa-whatsapp', color: '#25D366', label: 'WhatsApp' },
    { key: 'youtube', icon: 'fab fa-youtube', color: '#FF0000', label: 'YouTube' },
    { key: 'linkedin', icon: 'fab fa-linkedin-in', color: '#0A66C2', label: 'LinkedIn' },
    { key: 'pinterest', icon: 'fab fa-pinterest-p', color: '#E60023', label: 'Pinterest' },
    { key: 'website', icon: 'fas fa-globe', color: '#5B21B6', label: 'Sitio Web' }
  ];

  const icons = socialNetworks
    .filter((network) => socialMedia[network.key])
    .map((network) => {
      const hrefSafe = safeUrl(String(socialMedia[network.key] || ''));
      if (!hrefSafe) return '';

      const trackAttrs = (network.key === 'whatsapp' && businessId && businessName)
        ? `data-pya-track="whatsapp" data-biz-id="${encodeURIComponent(String(businessId))}" data-biz-name="${encodeURIComponent(String(businessName))}"`
        : '';

      return `
        <a href="${hrefSafe}"
           target="_blank"
           rel="noopener noreferrer"
           class="social-icon"
           style="color: ${network.color};"
           aria-label="${network.label}"
           title="${network.label}"
           ${trackAttrs}>
          <i class="${network.icon}"></i>
        </a>
      `;
    })
    .join('');

  return icons ? `<div class="fb-card-social">${icons}</div>` : '';
}

export function createSocialMediaIconsElement(socialMedia, businessId = null, businessName = null) {
  if (!socialMedia || typeof socialMedia !== 'object') {
    return null;
  }

  bindWhatsAppTrackingOnce();

  const socialNetworks = [
    { key: 'facebook', icon: 'fab fa-facebook-f', color: '#1877F2', label: 'Facebook' },
    { key: 'instagram', icon: 'fab fa-instagram', color: '#E4405F', label: 'Instagram' },
    { key: 'twitter', icon: 'fab fa-x-twitter', color: '#000000', label: 'X' },
    { key: 'tiktok', icon: 'fab fa-tiktok', color: '#000000', label: 'TikTok' },
    { key: 'whatsapp', icon: 'fab fa-whatsapp', color: '#25D366', label: 'WhatsApp' },
    { key: 'youtube', icon: 'fab fa-youtube', color: '#FF0000', label: 'YouTube' },
    { key: 'linkedin', icon: 'fab fa-linkedin-in', color: '#0A66C2', label: 'LinkedIn' },
    { key: 'pinterest', icon: 'fab fa-pinterest-p', color: '#E60023', label: 'Pinterest' },
    { key: 'website', icon: 'fas fa-globe', color: '#5B21B6', label: 'Sitio Web' }
  ];

  const wrap = document.createElement('div');
  wrap.className = 'fb-card-social';

  for (const network of socialNetworks) {
    if (!socialMedia[network.key]) continue;
    const hrefSafe = safeUrl(String(socialMedia[network.key] || ''));
    if (!hrefSafe) continue;

    const a = document.createElement('a');
    a.href = hrefSafe;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.className = 'social-icon';
    a.style.color = network.color;
    a.setAttribute('aria-label', network.label);
    a.title = network.label;

    if (network.key === 'whatsapp' && businessId && businessName) {
      a.setAttribute('data-pya-track', 'whatsapp');
      a.setAttribute('data-biz-id', encodeURIComponent(String(businessId)));
      a.setAttribute('data-biz-name', encodeURIComponent(String(businessName)));
    }

    const i = document.createElement('i');
    i.className = network.icon;
    a.appendChild(i);

    wrap.appendChild(a);
  }

  return wrap.childNodes.length ? wrap : null;
}
